'use client';

import { c as _c } from "react/compiler-runtime";
import { LogoArbitralis } from '@/shared/components/ui';
export const SimpleLogoHeader = () => {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <div className="flex border-b border-solid border-neutral-200 px-6 py-6 md:px-20"><LogoArbitralis className="[&_img]:h-6 [&_img]:w-auto" /></div>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
};